<template>
  <div class="container">
    <!-- 顶部渐变背景 -->
    <div class="header-bg"></div>

    <!-- 用户信息 -->
    <div class="user-info">
      <div class="avatar">
        <van-icon name="user-circle-o" size="40" />
      </div>
      <div class="user-name">
        <span>微信用户</span>
        <van-icon name="edit" size="16" />
      </div>
      <div class="user-id">ID: 346856835</div>
    </div>

    <!-- 功能按钮 -->
    <div class="function-buttons">
      <van-grid :column-num="2">
        <van-grid-item icon="edit" text="发布说明" />
        <van-grid-item icon="friends" text="咨询客服" />
      </van-grid>
    </div>

    <!-- 系统信息 -->
    <div class="system-info">
      <p>- 系统版本 v1.1.3 -</p>
      <p>当前数据查询范围：培训证书查询</p>
    </div>
  </div>
</template>
  
  <script>
import { Grid, GridItem, Button, Icon } from "vant";

export default {
  components: {
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Button.name]: Button,
    [Icon.name]: Icon,
  },

  data() {
    return {};
  },

  methods: {},
};
</script>
  
  <style scoped>
.container {
  position: relative;
  min-height: 100vh;
  background-color: #f5f5f5;
  padding-bottom: 10px;
}

.header-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 200px;
  background: linear-gradient(90deg, #0091ff, #64b5f6, #b3e5fc);
  border-radius: 0 0 32px 32px;
  z-index: 0;
}

.user-info {
  text-align: center;
  color: white;
}

.avatar {
  width: 80px;
  height: 80px;
  background-color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.user-name {
  font-size: 18px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  position: relative;
}

.user-id {
  background-color: white;
  color: #333;
  border-radius: 20px;
  padding: 5px 15px;
  display: inline-block;
  font-size: 14px;
  position: relative;
  top: -80px;
}

.function-buttons {
  background-color: white;
  border-radius: 16px;
  margin: 20px 20px 0;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  position: relative;
  top: -95px;
}

.question-bank {
  margin: 40px 20px;
}

.question-bank-button {
  background: linear-gradient(90deg, #0091ff, #64b5f6);
  color: white;
  border: none;
}

.system-info {
  text-align: center;
  margin: 20px;
  color: #666;
  font-size: 13px;
}

.clear-cache {
  background-color: white;
  border: 1px solid #ddd;
  padding: 8px 15px;
  border-radius: 4px;
  margin-top: 10px;
}

.footer {
  text-align: center;
  margin: 40px 0 20px;
  color: #666;
}
</style>